import { createFileRoute } from '@tanstack/react-router'

import UpdaterSectionPage from '@/features/Admin/UpdaterManagement/Components/UpdaterSectionPage.tsx'

export const Route = createFileRoute('/_authenticated/admin/updates/failed')({
    component: RouteComponent,
})

function RouteComponent() {
    return (
        <UpdaterSectionPage
            status="failed"
            titleKey="admin.updater.updatesFailed.title"
            descriptionKey="admin.updater.updatesFailed.description"
        />
    )
}
